const user = {
  state: {
    from_type: ''
  },

  mutations: {
    SET_FROMTYPE: (state, code) => {
      state.from_type = code
    }
  },

  actions: {
    // 设置来源
    setFromType ({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit('SET_FROMTYPE', '3')
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/service.js